
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pricing/[ab]",
      function () {
        return require("private-next-pages/pricing/[ab]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pricing/[ab]"])
      });
    }
  